import React, { createContext, useState, useContext, useEffect } from 'react';
import enTranslations from '../languages/en.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [translations, setTranslations] = useState(enTranslations);

  const loadTranslations = async (lang) => {
    try {
      let translation;
      if (lang === 'en') {
        translation = enTranslations;
      } else {
        const module = await import(`../languages/${lang}.json`);
        translation = module.default;
      }
      setTranslations(translation);
      setCurrentLanguage(lang);
      localStorage.setItem('preferredLanguage', lang);
    } catch (error) {
      console.error('Error loading translations:', error);
      // Hata durumunda varsayılan dile (İngilizce) geri dön
      setTranslations(enTranslations);
      setCurrentLanguage('en');
      localStorage.setItem('preferredLanguage', 'en');
    }
  };

  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage') || 'en';
    if (savedLang !== currentLanguage) {
      loadTranslations(savedLang);
    }
  }, []);

  return (
    <LanguageContext.Provider 
      value={{ 
        currentLanguage, 
        translations, 
        setCurrentLanguage: (lang) => loadTranslations(lang) 
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext); 